import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Typography from '../components/Typography';
import Button from '../components/Button';
import Input from '../components/Input';
import { useForm } from '../hooks/useForm';
import { makeStyles } from '@material-ui/core';
import { selectPerson } from '../redux/personDuck';
import { fetchQuote } from '../redux/quoteDuck';
import validate from '../helpers/validateFormPerson';

const useStyles = makeStyles({
  input: {
    width: '100%'
  }
});

const initialForm = {
  name: '',
  age: '',
  phone: ''
};

export const SeventhStep = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const classes = useStyles();
  const { car } = useSelector((state) => state);

  const handleSelectPerson = () => {
    dispatch(selectPerson(form));
    dispatch(fetchQuote(car));
    history.push('/cotizacion');
  };

  const { form, errors, validFields, handleChange, handleKeyUp, handleSubmit } = useForm(
    initialForm,
    validate,
    handleSelectPerson
  );

  return (
    <>
      <Typography text='Último paso! Tus datos' />
      <form onSubmit={handleSubmit} autoComplete='off' className={classes.form}>
        <Input
          name='name'
          type='text'
          label='Nombre'
          value={form.name}
          placeholder={errors.name && 'Ej. Cecilia'}
          onChange={handleChange}
          onKeyUp={handleKeyUp}
          className={classes.input}
          error={errors.name}
          valid={validFields.name}
          inputProps={{
            maxLength: 60
          }}
        />
        <Input
          name='age'
          type='tel'
          label='Edad'
          value={form.age}
          placeholder={errors.age && 'Ej. 21'}
          onChange={handleChange}
          onKeyUp={handleKeyUp}
          className={classes.input}
          error={errors.age}
          valid={validFields.age}
          inputProps={{
            maxLength: 2
          }}
        />
        <Input
          name='phone'
          type='tel'
          label='Teléfono'
          value={form.phone}
          placeholder={errors.phone && 'Ej. 1133445566'}
          onChange={handleChange}
          onKeyUp={handleKeyUp}
          className={classes.input}
          error={errors.phone}
          valid={validFields.phone}
          inputProps={{
            maxLength: 15
          }}
        />
        <Button text='Cotizar' type='submit' color='secondary' />
      </form>
    </>
  );
};
